import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const LifeInsuranceInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section life-insurance-fin">
                <h2 className="other-pages-title">Life Insurance</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/life-insurance-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Life Insurance</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is Life Insurance?</h2>

                <p className="info-loan-description-smco">
                    Life insurance is a contract between an individual and an insurance company, where the insurer promises to pay a designated beneficiary a sum of money upon the insured person's death. It provides financial protection and security for loved ones, ensuring that they are not burdened with financial difficulties in the event of the policyholder's untimely demise.
                    <br /><br />
                    There are several types of life insurance policies, including term life insurance, whole life insurance, universal life insurance, and endowment plans. Each type offers different benefits, coverage periods, and premium structures to suit various needs and budgets. Life insurance not only provides death benefits but can also serve as a savings and investment tool.
                    <br /> <br />
                    Premiums for life insurance are determined by factors such as age, health, lifestyle, occupation, and the type and amount of coverage. While term insurance offers pure protection at lower costs, permanent policies combine protection with savings components. Riders can be added to customize coverage for specific needs like critical illness or disability.
                    <br /><br />
                    Life insurance is an essential component of financial planning. It provides peace of mind, helps in estate planning, and can offer tax benefits. Choosing the right policy requires careful consideration of your family's needs, financial goals, and risk tolerance. Consulting with insurance experts can help you make informed decisions.
                    <br />
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Death benefit:</strong> Guaranteed payout to beneficiaries upon death.</li>
                        <li><strong>Flexible coverage:</strong> Options for different coverage amounts and terms.</li>
                        <li><strong>Savings component:</strong> Some policies offer investment and savings benefits.</li>
                        <li><strong>Tax advantages:</strong> Premiums and benefits may be tax-exempt.</li>
                        <li><strong>Riders available:</strong> Additional coverage for specific risks.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Types of Life Insurance</h3>
                    <ul className="info-types-list-smco">
                        <li><strong>Term Life Insurance:</strong> Pure protection for a specified period.</li>
                        <li><strong>Whole Life Insurance:</strong> Lifetime coverage with cash value accumulation.</li>
                        <li><strong>Universal Life Insurance:</strong> Flexible premiums and death benefits.</li>
                        <li><strong>Endowment Plans:</strong> Combination of insurance and savings.</li>
                        <li><strong>ULIPs:</strong> Unit-linked insurance plans with investment options.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Financial security:</strong> Protects family from financial hardship.</li>
                        <li><strong>Estate planning:</strong> Helps in wealth transfer and tax planning.</li>
                        <li><strong>Peace of mind:</strong> Assurance for the future well-being of loved ones.</li>
                        <li><strong>Investment opportunity:</strong> Some policies offer growth potential.</li>
                        <li><strong>Loan facility:</strong> Policy can be used as collateral for loans.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default LifeInsuranceInfo;
